import { rangeBounds, sortItems } from '@/utils/filters';

export const sortColumnOptions = [
  { value: 'name', label: 'Name', defaultDirection: 'asc' },
  { value: 'category', label: 'Category' },
  { value: 'subcategory', label: 'Subcategory' },
  { value: 'kcal', label: 'Kcal' },
  { value: 'protein', label: 'Protein' },
  { value: 'fat', label: 'Fat' },
  { value: 'carbs', label: 'Carbs' },
  { value: 'fiber', label: 'Fiber' },
  { value: 'density', label: 'Density' },
  { value: 'recipe_match_count', label: 'Recipes' },
];

export const DEFAULT_SORT_COLUMN = 'name';

const sortValueGetters = {
  name: (ingredient) => ingredient.name.toLowerCase(),
  category: (ingredient, getCategoryName) => getCategoryName(ingredient).toLowerCase(),
  subcategory: (ingredient, getCategoryName, getSubcategoryName) => getSubcategoryName(ingredient).toLowerCase(),
  kcal: (ingredient) => ingredient.kcal,
  protein: (ingredient) => ingredient.protein,
  fat: (ingredient) => ingredient.fat,
  carbs: (ingredient) => ingredient.carbs,
  fiber: (ingredient) => ingredient.fiber,
  density: (ingredient) => ingredient.density,
  recipe_match_count: (ingredient) => ingredient.recipe_match_count,
};

export function sortIngredients(ingredients, sort, getCategoryName, getSubcategoryName) {
  return sortItems(ingredients, sort, sortValueGetters, DEFAULT_SORT_COLUMN, getCategoryName, getSubcategoryName);
}

const RANGE_FIELDS = ['kcal', 'protein', 'fat', 'carbs', 'fiber', 'density', 'piece_weight', 'slice_weight', 'package_size', 'portion_size'];

export function filterIngredients(ingredients, filters, getCategoryName, getSubcategoryName) {
  return ingredients.filter((ingredient) => {
    let matches = true;

    if (filters.categories.length > 0) {
      matches &= filters.categories.includes(getCategoryName(ingredient));
    }

    if (filters.subcategories.length > 0) {
      matches &= filters.subcategories.includes(getSubcategoryName(ingredient));
    }

    if (filters.preferredUnits.length > 0) {
      matches &= filters.preferredUnits.includes(ingredient.preferred_unit);
    }

    if (filters.commonOnly) {
      matches &= !!ingredient.common;
    }

    for (const field of RANGE_FIELDS) {
      const range = filters[field];
      if (range && ingredient[field] != null) {
        matches &= ingredient[field] >= range[0] && ingredient[field] <= range[1];
      }
    }

    return matches;
  });
}

export function computeIngredientBounds(ingredients) {
  const bounds = {};

  for (const field of RANGE_FIELDS) {
    bounds[field] = rangeBounds(ingredients.map((ingredient) => ingredient[field]));
  }

  return bounds;
}
